export default {
  ticketList: {
    data:[],
  },
  ticketCategorized: {
    data:[],
  },
  ticketListAll: {
    data:[],
  },
  ticketCategoryValuePairs: [],
  ticketCategoryList: [],
  ticketCategoryData: [],
  feedback: {},
  solutionUserValuePairs: [],
  ticketComments: [],

};



// WEBPACK FOOTER //
// ./src/store/modules/ticket/state.js